import React from 'react';
import yoga2 from '../assets/Yoga/2.svg';
import logo from '../assets/logo.png';
import {Button} from 'react-bootstrap';
import {Link} from 'react-router-dom';

const Yoga = () => {
    return (
        <div className="container-yoga">
            <div className="logo">
            <img src={logo} alt="TheAfterSchool.Club" />
            </div>
            <div className="yoga-content-head">
            YOGA’ o clock : Yoga classes for Kids &amp; Adults
            </div>
            <div className="yoga-content-para">
            Do you ever feel that you work throughout the week and there are situations
wherein you don’t even have time to catch your breath? Hold that breath right
there, because once you step into YOGA’O clock, we help you in releasing your
breath, literally and figuratively. Escape from the hustle &amp; bustle of life and take
some time off for yourself.
Ohh, and we’re also planning to slightly take your breath away by adding some
physical exercises to it as well so that you don’t feel guilty later on. Yep, we’ve all
been there.
            </div>
            <div className="yoga-content-points">
            Duration : 3 months<br></br>
            Frequency : 2-3 classes per week<br></br>
            </div>
            <div className="yoga-content-button">
                <Link to="/contact"><Button><div className="yoga-content-button-text">Contact Us</div></Button></Link>
            </div>
            <div className="svg2">
                <img src={yoga2} alt="yoga2" id="yoga2"></img>
            </div>
        </div>
    );
}

export default Yoga;